<template>
  <v-main>
    <v-container fluid>
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
      <div style="position: relative">
        <v-btn
          v-if="readOnly"
          absolute
          fab
          top
          right
          dark
          color="primary"
          @click="editItem"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </div>
      <br />
      <br />
      <form>
        <v-row dense>
          <v-col cols="12" sm="10" md="10">
            <h5>Gambar</h5>
            <v-img
              v-if="agenda_pelatihan.foto_url_original"
              :src="agenda_pelatihan.foto_url"
              contain
              :key="agenda_pelatihan.fotoKey"
              max-height="1000"
            ></v-img>
            <v-img
              v-else
              src="https://www.generationsforpeace.org/wp-content/uploads/2018/03/empty.jpg"
              contain
              max-height="300"
            ></v-img>
            <v-file-input
              v-if="!readOnly"
              @change="loadImage"
              accept="image/*"
              v-model="agenda_pelatihan.poster_url"
              prepend-icon="mdi-image"
              show-size
              label="Gambar (1000x1510) px"
            />
          </v-col>
        </v-row>
        <v-row v-if="!readOnly">
          <v-col cols="12" class="d-flex justify-end">
            <v-btn @click="doBatal" style="margin-right: 10px">Batal</v-btn>
            <v-btn dark color="primary" type="submit" @click.prevent="doSubmit"
              >Simpan</v-btn
            >
          </v-col>
        </v-row>
      </form>
    </v-container>
  </v-main>
</template>

<script>
import AgendaPelatihanService from "../../services/web_content/AgendaPelatihanService";
import CommonService from "../../services/CommonService";

export default {
  name: "AgendaPelatihan",
  components: {},
  props: {},
  data: () => ({
    breadcrumbs: [
      {
        text: "Agenda Pelatihan",
        disabled: false,
        exact: true,
        to: { name: "AgendaPelatihan" },
      },
      { text: "Detail", disabled: true },
    ],
    readOnly: true,
    agenda_pelatihan: {
      id: null,
      foto_url_original: null,
      foto_url: null,
      fotoKey: 0,
      poster_url: null,
    },
  }),
  computed: {
    outlined() {
      return this.readOnly;
    },
    hideDetails() {
      return true;
    },
  },
  mounted: async function () {
    this.fetch();
  },
  methods: {
    loadImage: function (data) {
      console.log("loadImage:", data);
      if (data) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.agenda_pelatihan.foto_url = e.target.result;
          this.agenda_pelatihan.foto_url_original =
            this.agenda_pelatihan.foto_url;
          this.agenda_pelatihan.fotoKey++;
        };
        reader.readAsDataURL(data);
      }
    },
    fetch: async function () {
      try {
        console.log("fetch");
        AgendaPelatihanService.agendaPelatihan()
          .then((res) => {
            if (res.data.agenda_pelatihan) {
              this.agenda_pelatihan = res.data.agenda_pelatihan;
            }
            console.log(this.agenda_pelatihan);
            console.log(this.agenda_pelatihan.id);
          })
          .catch((err) => {
            console.log(err);
          });
      } catch (e) {
        console.error("error:", e);
      }
    },

    editItem: async function () {
      this.readOnly = false;
    },

    doBatal: function () {
      this.readOnly = true;
    },

    doSubmit: async function () {
      try {
        console.log(this.agenda_pelatihan.id);
        if (this.agenda_pelatihan.id != null) {
          AgendaPelatihanService.update(this.agenda_pelatihan)
            .then((res) => {
              console.log(res);
              CommonService.showSuccessToast(
                "Update agenda pelatihan berhasil"
              );

              this.fetch();
              this.readOnly = true;
            })
            .catch((err) => {
              console.log(err);
              CommonService.showErrorToast(
                "Update agenda pelatihan gagal. Coba lagi"
              );
            });
        } else {
          AgendaPelatihanService.create(this.agenda_pelatihan)
            .then((res) => {
              console.log(res);
              this.dialog = false;
              CommonService.showSuccessToast(
                "Tambah agenda pelatihan berhasil"
              );

              this.fetch();
              this.readOnly = true;
            })
            .catch((err) => {
              console.log(err);
              CommonService.showErrorToast(
                "Tambah agenda pelatihan gagal. Coba lagi"
              );
            });
        }
      } catch (e) {
        console.error("error:", e);
      }
    },
  },
};
</script>

<style scoped>
</style>
